import React, { Component } from "react";
import { uploadWidget, withRedux } from "helpers";
import {
  Image,
  SmallModal,
  FlexRow,
  Button,
  FlexColumn,
  Label,
} from "appStyles";
import { css } from "react-emotion";

const labelStyle = css`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 0.9375rem;
  line-height: 0.9375rem;
  display: flex;
  align-items: flex-end;
  letter-spacing: 0.4px;
`;
class ImageComponent extends Component {
  state = {
    hideModal: true,
  };

  displayModal = () => {
    // console.log("displaying image modal...");
    if (!this.props.disabled) this.setState({ hideModal: false });
  };

  hideModal = () => {
    this.setState({ hideModal: true });
  };

  render() {
    const {
      imageUrl,
      uploadImage,
      removeImage,
      title,
      titleWidth,
      editMode,
      options,
      disabled,
      displayLabel,
      displayImage,
      isMobileAdminView,
      activeApp: { id, name },
    } = this.props;

    const { hideModal } = this.state;

    // console.dir(this.props.options);

    return (
      <div
        style={{
          position: "relative",
          display: displayImage ? displayImage : "block",
        }}
      >
        <FlexRow width={isMobileAdminView ? "100%" : "45%"} height="auto">
          <Label
            title={title}
            style={{
              width: titleWidth ? titleWidth : "220px",
              display: displayLabel ? displayLabel : "inline-block",
            }}
          >
            {title}{" "}
          </Label>
          <FlexRow width={isMobileAdminView ? "fit-content" : "53%"}>
            {imageUrl ? (
              <Image
                width={this.props.width}
                height={this.props.height}
                cursor="pointer"
                onClick={this.displayModal}
                src={imageUrl}
              />
            ) : (
              <Image
                width={this.props.width}
                height={this.props.height}
                cursor="pointer"
                onClick={this.displayModal}
                src="https://mobile360-assets.s3.us-east-2.amazonaws.com/upload.png"
              />
            )}
            <SmallModal
              hidden={hideModal}
              top="0"
              left={isMobileAdminView ? "auto" : "7em"}
              right={isMobileAdminView ? "0%" : "auto"}
              width="auto"
              height="auto"
            >
              <FlexColumn>
                <FlexRow>
                  <Button
                    background="#4AAD87"
                    onClick={() => {
                      uploadWidget(uploadImage, id, options);
                      this.hideModal();
                    }}
                  >
                    {imageUrl ? "Replace" : "New Image"}
                  </Button>
                  {(imageUrl || editMode) && (
                    <Button
                      background="#F17F7F"
                      onClick={() => {
                        removeImage ? removeImage() : uploadImage(null);
                        this.hideModal();
                      }}
                    >
                      Delete
                    </Button>
                  )}
                  <Button background="black" onClick={this.hideModal}>
                    Cancel
                  </Button>
                </FlexRow>
              </FlexColumn>
            </SmallModal>
          </FlexRow>
        </FlexRow>
      </div>
    );
  }
}

export default withRedux(ImageComponent);
